import { Platform, type ViewStyle } from 'react-native';

// Explicit shadow so the session card lifts on every platform (NativeWind can't
// resolve the Tailwind shadow token to RN's native shadow on iOS).
export const NATIVE_CARD_SHADOW: ViewStyle | undefined = Platform.select({
  ios: {
    shadowColor: '#000',
    shadowOffset: { width: 0, height: 4 },
    shadowOpacity: 0.1,
    shadowRadius: 6,
  },
  android: { elevation: 4 },
  default: undefined,
});
